// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
  <sub-header header="'Agent application'">
    <button type="button"
              command-access="CreateAgentCandidacy"
              class="btn btn-primary"
              ng-click="\$ctrl.createApplication()">
        New application
      </button>
    </sub-header>

<ng-form class="filters" name="\$ctrl.form">
  <div class="labelled-field labelled-field--long">
    <label for="filter-branch" class="add-on">Branch</label>
    <branch-filter
      ng-if="\$ctrl.availableBranches"
      id="filter-branch"
      ng-model="\$ctrl.filter.branchIds"
      options="\$ctrl.availableBranches"
      ng-change="\$ctrl.onBranchChange()"
      class="form-control"
      ng-required="true"
      ng-model-options="{ allowInvalid: true }"
    >
    </branch-filter>
  </div>
  <div class="labelled-field labelled-field--long">
    <label for="filter-agent" class="add-on">Agent</label>
    <multiselect id="filter-agent"
                 items="\$ctrl.agentsFullNames"
                 ng-model="\$ctrl.filter.agentFullNames"
                 select-all-option="true"
                 ng-required="true">
    </multiselect>
  </div>
  <div class="labelled-field labelled-field--long">
    <label for="filter-status" class="add-on">Status</label>
    <multiselect id="filter-status"
                 class="form-control"
                 ng-model="\$ctrl.filter.statuses"
                 items="\$ctrl.candidacyStatuses"
                 select-all-option="true"
                 ng-required="true">
    </multiselect>
  </div>
  <date-range-picker model="\$ctrl.filter.dateRange"></date-range-picker>
  <button ng-click="\$ctrl.reloadTable()" ng-disabled="\$ctrl.form.\$invalid" class="btn btn-primary btn--filter">
    Filter
  </button>
</ng-form>
  <table class="table table--generate-row-ids table--last-column-to-right" ng-table="\$ctrl.tableConfig">
    <thead>
    <tr>
      <th>No.</th>
      <th>Branch</th>
      <th>Agent full name</th>
      <th>Agent code</th>
      <th>Status</th>
      <th>Created on</th>
      <th>Actions</th>
    </tr>
    </thead>
    <tbody>
    <tr ng-repeat="application in \$data">
      <td></td>
      <td>{{ application.branchName }}</td>
      <td>{{ application.effectiveName }}</td>
      <td>{{ application.code }}</td>
      <td>{{ application.status | prettyEnum }}</td>
      <td>{{ application.createdOn | prettyDate }}</td>
      <td>
        <div class="summary-actions">
          <button type="button"
                  class="btn btn-primary"
                  ng-if="\$ctrl.canCreateAgent(application)"
                  command-access="CreateAgent"
                  ng-click="\$ctrl.createAgent(application)">
            Create Agent
          </button>
          <button type="button"
                  class="btn btn-success"
                  ng-if="['CLIENT_ELIGIBILITY_EVALUATED'].includes(application.status) && ['NEW'].includes(application.systemStatus)"
                  command-access="SendForApproval"
                  ng-click="\$ctrl.sendForApproval(application)">
            Send for Approval
          </button>
          <button class="btn btn-primary"
                  ng-if="['CLIENT_ELIGIBILITY_EVALUATED'].includes(application.status) && ['SENT_FOR_APPROVAL'].includes(application.systemStatus)"
                  command-access="ApproveAgentCandidacy,DisapproveAgentCandidacy"
                  ng-click="\$ctrl.process(application)">
            Process
          </button>
          <button class="btn btn-primary"
                  ng-if="\$ctrl.isEditable(application)"
                  command-access="UpdateAgentCandidacy"
                  ng-click="\$ctrl.edit(application)">
            Edit
          </button>
          <button class="btn btn-danger"
                  ng-if="['APPLICATION_FORM_COMPLETE'].includes(application.status)"
                  command-access="DeleteAgentCandidacy"
                  ng-click="\$ctrl.delete(application)">
            Delete
          </button>
          <button type="button"
                  class="btn btn-info"
                  ng-if="application.customerId != null"
                  ng-click="\$ctrl.openCIF(application)">
            CIF
          </button>
          <button class="btn btn-info"
                  ng-click="\$ctrl.view(application)">
            View
          </button>
        </div>
      </td>
    </tr>
    </tbody>
  </table>

<div ng-if="!(\$ctrl.tableConfig.total() > 0)"
     class="empty-message">
  <span>There are no applications matching Filter criteria.</span>
</div>
</section>

`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/agent-banking/candidacy/agent-candidacy-list.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;